<template>
  <div class="hiw">
    <div class="row">
      <div class="col-lg-12 header-text">
        <h1>{{ $t('views.how-it-works.anEasyWay') }}<span class="blue">{{ $t('views.how-it-works.passiveIncome') }}</span>{{ $t('views.how-it-works.works') }}</h1>
        <h3>{{ $t('views.how-it-works.bothIndividualsAnd') }}</h3>
      </div>
    </div>
    <div class="container">
      <div class="col-lg-12 hiw-steps d-none d-xl-block d-lg-block d-md-block">
        <div class="row">
          <div class="col-12 col-md-5 col-lg-5 col-xl-5">
          </div>
          <div class="col-12 col-md-2 col-lg-2 col-xl-2 numbers">
            <h2 class="blue">01</h2>
            <div class="dots">
              <div class="dot" v-for="n in 5" v-bind:key="n"></div>
            </div>
          </div>
          <div class="col-12 col-md-5 col-lg-5 col-xl-5">
            <h2>{{ $t('views.how-it-works.register') }}</h2>
            <h3>{{ $t('views.how-it-works.toGetStarted') }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-5 col-lg-5 col-xl-5">
            <h2>{{ $t('views.how-it-works.addFundsTo') }}</h2>
            <h3>{{ $t('views.how-it-works.addFundsTo1') }}</h3>
          </div>
          <div class="col-12 col-md-2 col-lg-2 col-xl-2 numbers">
            <h2 class="blue">02</h2>
            <div class="dots">
              <div class="dot" v-for="n in 5" v-bind:key="n"></div>
            </div>
          </div>
          <div class="col-12 col-md-5 col-lg-5 col-xl-5">
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-5 col-lg-5 col-xl-5">
          </div>
          <div class="col-12 col-md-2 col-lg-2 col-xl-2 numbers">
            <h2 class="blue">03</h2>
            <div class="dots">
              <div class="dot" v-for="n in 5" v-bind:key="n"></div>
            </div>
          </div>
          <div class="col-12 col-md-5 col-lg-5 col-xl-5">
            <h2>{{ $t('views.how-it-works.invest') }}</h2>
            <h3>{{ $t('views.how-it-works.investByManually') }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-5 col-lg-5 col-xl-5">
            <h2>{{ $t('views.how-it-works.getIncome') }}</h2>
            <h3>{{ $t('views.how-it-works.seeYourInvestment') }}</h3>
          </div>
          <div class="col-12 col-md-2 col-lg-2 col-xl-2 numbers">
            <h2 class="blue">04</h2>
            <div class="dots">
              <div class="dot" v-for="n in 5" v-bind:key="n"></div>
            </div>
          </div>
          <div class="col-12 col-md-5 col-lg-5 col-xl-5">
          </div>
        </div>
      </div>
      <!-- MOBILE/TABLET view -->
      <div class="col-lg-12 hiw-steps d-xl-none d-lg-none d-md-none">
        <div class="row mobile-row">
          <div class="col-2 numbers">
            <h2 class="blue">01</h2>
            <div class="dots">
              <div class="dot" v-for="n in 5" v-bind:key="n"></div>
            </div>
          </div>
          <div class="col-10">
            <h2>{{ $t('views.how-it-works.register') }}</h2>
            <h3>{{ $t('views.how-it-works.toGetStarted') }}</h3>
          </div>
        </div>
        <div class="row mobile-row">
          <div class="col-2 numbers">
            <h2 class="blue">02</h2>
            <div class="dots">
              <div class="dot" v-for="n in 5" v-bind:key="n"></div>
            </div>
          </div>
          <div class="col-10">
            <h2>{{ $t('views.how-it-works.addFundsTo') }}</h2>
            <h3>{{ $t('views.how-it-works.addFundsTo1') }}</h3>
          </div>
        </div>
        <div class="row mobile-row">
          <div class="col-2 numbers">
            <h2 class="blue">03</h2>
            <div class="dots">
              <div class="dot" v-for="n in 5" v-bind:key="n"></div>
            </div>
          </div>
          <div class="col-10">
            <h2>{{ $t('views.how-it-works.invest') }}</h2>
            <h3>{{ $t('views.how-it-works.investByManually') }}</h3>
          </div>
        </div>
        <div class="row mobile-row">
          <div class="col-2 numbers">
            <h2 class="blue">04</h2>
            <div class="dots">
              <div class="dot" v-for="n in 5" v-bind:key="n"></div>
            </div>
          </div>
          <div class="col-10">
            <h2>{{ $t('views.how-it-works.getIncome') }}</h2>
            <h3>{{ $t('views.how-it-works.seeYourInvestment') }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="ensuring-description">{{ $t('views.how-it-works.onIncomeMarketplace') }}</div>
    <div class="text-center security-features">
      {{ $t('views.how-it-works.secure-features') }}
    </div>
    <div class="row key-usability">
      <div class="container info-data">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="info-icon"><img alt="" src="../assets/listing.svg"></div>
            <div class="info-value de-break-word">{{ $t('views.how-it-works.chooseStrategy') }}</div>
            <div class="desc">{{ $t('views.how-it-works.allLoansCome') }}</div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="info-icon"><img alt="" src="../assets/money.svg"></div>
            <div class="info-value">{{ $t('views.how-it-works.invest2') }}</div>
            <div class="desc">{{ $t('views.how-it-works.onceYouHave') }}
              <a href="https://getincome.com/blog/is-income-the-safest-marketplace-to-invest-in-loans-explaining-the-cashflow-buffer/">{{ $t('views.how-it-works.readMore')}}</a>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="info-icon"><img alt="" src="../assets/search.svg"></div>
            <div class="info-value">{{ $t('views.how-it-works.track') }}</div>
            <div class="desc">{{ $t('views.how-it-works.useOurInteractive') }}
              <a href="https://getincome.com/blog/junior-share-vs-skin-in-the-game/">{{ $t('views.how-it-works.readMore')}}</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center income-works">
      {{ $t('views.how-it-works.incomeWorks') }}<br/>
      {{ $t('views.how-it-works.incomeWorks1') }}
    </div>
    <div class="container hiw-schema">
      <img v-bind:src="getSrc($t('views.how-it-works.hiwSchemaImg'))" alt=""/>
    </div>
    <div class="col-lg-12 ">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6 col-xl-6">
            <div class="left-section">
              <div class="our-promise introduction">
                <h1>{{ $t('views.how-it-works.estIntroduction') }}<span class="blue">{{ $t('views.how-it-works.introduction') }}</span>{{ $t('views.how-it-works.toTheInncome') }}</h1>
                <div>
                  <div class="description">{{ $t('views.how-it-works.introductionDescription') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-6 col-xl-6 col-video">
            <iframe width="100%" height="304" src="https://www.youtube.com/embed/U2rV3pNhTnE" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="home-start-investing">
            <h2>{{ $t('views.how-it-works.startInvestingToday') }}</h2>
            <div class="detail-info">{{ $t('views.how-it-works.earnUpTo') }}</div>
            <get-started/>
          </div>
        </div>
      </div>
    </div>
    <how-to-schema/>
  </div>
</template>

<script>
import GetStarted from '../components/GetStarted'
import HowToSchema from '@/schema/HowToSchema'
import imageMixin from '../mixins/image'

export default {
  name: 'How-it-works',
  mixins: [imageMixin],
  components: {
    GetStarted,
    HowToSchema
  }
}
</script>

<style scoped lang="scss">

.header-text {
  margin: 82px auto 16px;
  text-align: center;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    margin: auto auto 15px;

    .blue {
      color: #30A7FE;
    }
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.ensuring-fairness {
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;
  width: 100%;

  h2 {
    margin-top: 50px;
    margin-bottom: 16px;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
  }

  .steps-descriptions {
    display: inline-block;
    max-width: 610px;
    text-align: center;
    margin-bottom: 45px;
  }
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}

.ensuring-description {
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #6E777A;
  max-width: 800px;
  margin: auto auto 65px;
}

.info-data {

  text-align: center;
  margin-top: 50px;

  .info-icon {
    img {
      width: 30px;
      margin-bottom: 30px;
    }
  }

  .info-value {
    font-style: normal;
    font-weight: bold;
    font-size: 34px;
    line-height: 40px;
    color: #000000;
    margin-bottom: 15px;
  }

  .desc {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #6E777A;
  }
}

[lang="de"] {
  .info-data {
    .info-value {
      text-align: justify;
      font-size: 28px;
    }
    .desc {
      text-align: justify;
    }
  }
}

.friendly-platform {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  background-image: url("../assets/friendly-platform.png");
  background-position: right 0;
  background-repeat: no-repeat;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;

  .circle {
    background: #30A7FE;
    border-radius: 135px;
    border: 60px solid #30A7FE;
    font-weight: bold;
    text-align: center;
    color: #FFFFFF;
    max-width: 270px;
    font-style: normal;
    padding-top: 60px;
    padding-bottom: 60px;
    margin-top: 45px;
    margin-left: -45px;
    font-size: 36px;
    line-height: 30px;
  }

  .text {
    margin-top: 100px;
    margin-bottom: 100px;
    margin-left: 50px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin: 0 16px;
    }

    .info {
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 28px;
      color: #6E777A;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 0 16px;
    }
  }
}

.equal-opportunity {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  background-image: url("../assets/equal-opportunity.png");
  background-position: left 0;
  background-repeat: no-repeat;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;

  .circle {
    background: #30A7FE;
    border-radius: 108px;
    border: 3px solid #30A7FE;
    font-weight: bold;
    text-align: center;
    color: #FFFFFF;
    font-style: normal;
    padding-top: 61px;
    padding-bottom: 61px;
    margin: 33% -19% 0 72%;
    font-size: 22px;
    line-height: 30px;
    max-width: 185px;
  }

  .text {
    margin-top: 100px;
    margin-bottom: 100px;
    margin-left: 50px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin: 0 16px;
    }

    .info {
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 28px;
      color: #6E777A;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 0 16px;
    }
  }
}

.key-usability {
  text-align: center;
  margin-bottom: 30px;

  .key-header {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #000000;
    margin-bottom: 20px;
    margin-top: 60px;
    display: inline-block;
    width: 100%;
  }
}

@media only screen and (max-width: 1024px) {
  .equal-opportunity, .friendly-platform {
    background: transparent;

    .text {
      margin: 10px
    }

    .circle {
      margin: 10px;
    }
  }
  .equal-opportunity {
    .circle {
      padding-top: 85px;
      padding-bottom: 85px;
      border-radius: 130px;
      max-width: 230px;
    }
  }
}

.hiw-steps {
  margin-top: 50px;
  margin-bottom: 50px;

  h2{
    @media (max-width: 525px) {
      font-size: 45px;
      line-height: 55px;
    }
    @media (max-width: 325px) {
      font-size: 38px;
      line-height: 45px;
    }
  }
  .numbers {
    text-align: center;
    font-size: 21px;
    line-height: 28px;
    font-weight: bold;
    color: #30A7FE;
  }

  h3 {
    margin-top: 15px;
    color: #80888B;
    font-size: 21px;
    @media (max-width: 525px) {
      line-height: 45px;
    }
    @media (max-width: 325px) {
      line-height: 40px;
    }
  }

  .dots {
    text-align: center;
    display: inline-block;

    .dot {
      background: #C4C4C4;
      border: 2px solid #C4C4C4;
      width: 8px;
      height: 8px;
      margin-top: 8px;
      margin-bottom: 8px;
      border-radius: 8px;
    }
  }

}

.hiw-schema {
  margin-top: 45px;
  margin-bottom: 85px;

  img {
    width: 100%;
  }
}

.footer-blocks {
  border: 1px solid #D6D6D6;
  margin-left: 15px;
  padding: 0;
  border-radius: 5px;

  img {
    width: 100%;
  }

  .info {
    padding: 10px;
    margin: 10px 30px;
    font-size: 16px;
    line-height: 28px;
    color: #6E777A;
  }
}

.mobile-row {
  margin-bottom: 10px;
}

.security-features, .income-works{
  font-style: normal;
  font-weight: bold;
  font-size: 34px;
  line-height: 40px;
  color: #000000;
  margin-top: 15px;
}

.income-works{
  margin-top: 80px;
  text-align: center;
}

.introduction
{
  margin-bottom: 15px;
  h1 {
    font-size: 3rem;
    font-weight: bold;
    line-height: 64px;
    @media (max-width: 768px) {
      line-height: normal;
    }
  }
  .description {
    margin-top: 20px;
  }
}
</style>
